import Immutable from 'immutable';

import actionTypes from 'src/constants/actionTypes';
import INITIAL_STATE from './initialState';

export default function (state = INITIAL_STATE, { payload, type }) {
  switch (type) {
    case actionTypes.FEATURED_COLLECTION__ADD_FAILURE:
      return state.withMutations(map => {
        map.set('errors', Immutable.fromJS(payload.errors));
        map.set('isActive', false);
      });

    case actionTypes.FEATURED_COLLECTION__ADD_START:
    case actionTypes.FEATURED_COLLECTION__GET_ALL_START:
    case actionTypes.FEATURED_COLLECTION__SHOW_START:
      return state.withMutations(map => {
        map.set('errors', null);
        map.set('isActive', true);
      });

    case actionTypes.FEATURED_COLLECTION__ADD_SUCCESS:
      return state.withMutations(map => {
        const { data : collection } = payload;

        map.set('isActive', false);
        map.set('lastAddedName', collection && collection.name);
      });

    case actionTypes.FEATURED_COLLECTION__CLEAR_TEMP_STATE:
      return state.withMutations(map => {
        map.set('errors', null);
        map.set('isActive', false);
        map.set('lastAddedName', null);
      });

    case actionTypes.FEATURED_COLLECTION__GET_ALL_FAILURE:
      return state.withMutations(map => {
        map.set('errors', Immutable.fromJS(payload.errors));
        map.set('isActive', false);
        map.setIn(['loaded', 'all'], Immutable.fromJS([]));
      });

    case actionTypes.FEATURED_COLLECTION__GET_ALL_SUCCESS:
      return state.withMutations(map => {
        const { data : collections } = payload;

        map.setIn(['loaded', 'all'], Immutable.fromJS(collections));
        map.set('isActive', false);
      });

    case actionTypes.FEATURED_COLLECTION__SHOW_FAILURE:
      return state.withMutations(map => {
        map.set('errors', Immutable.fromJS(payload.errors));
        map.set('isActive', false);
        map.setIn(['loaded', 'show'], Immutable.fromJS({}));
      });

    case actionTypes.FEATURED_COLLECTION__SHOW_SUCCESS:
      return state.withMutations(map => {
        const { data : collection } = payload;

        map.setIn(['loaded', 'show'], Immutable.fromJS(collection));
        map.set('isActive', false);
      });

    default:
      return state;
  }
}
